import React, { Component, useEffect, useState } from "react";

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { PostApi } from "../../../js_assets/Network";
import axios from "axios";
import { api_url } from "../../../js_assets/ConfigApp";
import { GetApi } from "../../../js_assets/Network";
import CircularProgress from "@material-ui/core/CircularProgress";
import List from "@material-ui/core/List";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const styles = (theme) => ({
    divider: {
        width: "100%",
    },
    ButtonGuide: {
        backgroundColor: "#74cbc4",
        color: "white",
        "&:hover": {
            background: "#74cbc4",
        },
        margin: theme.spacing.unit,
        padding: "5px",
        borderRadius: "5px",
        fontSize: 15,
        boxShadow: " 0 4px 8px 0 rgba(0,0,0,0.2);",
        fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
    },
    iocns: {
        fontSize: 18,
    },
    canceliocn: {
        color: "black",
        float: "left",
    },
    p_followUp_Schedule_Description: {
        maxWidth: 270,
        lineHeight: "2.7em",
    },
    ButtonSubscription: {
        backgroundColor: "#74cbc4",
        color: "white",
        "&:hover": {
            background: "#74cbc4",
        },
        fontSize: 15,
        boxShadow: " 0 4px 8px 0 rgba(0,0,0,0.2);",
        fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
    },
    btn_login: {
        color: "white",
        padding: "10px 1px",
        border: "none",
        cursor: "pointer",
        width: "100%",
        opacity: "0.9",
        borderRadius: "3px",
        fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
    },
    tab: {
        flexGrow: 1,
        marginTop: -5,
        backgroundColor: "#f7faea",
        fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
    },
    tab_button: {
        fontSize: 18,
        fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
    },
});

function TrainerRating(props) {


    const [loading_state_iocn, setLoading_state_iocn] = useState(true);
    const [open_DialogContent_trainer_Rating, setOpen_DialogContent_trainer_Rating] = useState(true);
    const [trainer_Rating_data, setTrainer_Rating_data] = useState([]);
    const { classes } = props;
    const Admin_Info = JSON.parse(localStorage.getItem("Admin_Info"))



    useEffect(() => {
        handleopen_DialogContent_trainer_Rating(props.TrainerID)

    }, [props.TrainerID]);


    const handleopen_DialogContent_trainer_Rating = (TrainerID) => {
        axios.get(`${api_url}/api/Trainer/Get_Rating_Trainer/${TrainerID}`)
            .then((result) => {
                setTrainer_Rating_data(result.data)
                setLoading_state_iocn(false)
                setOpen_DialogContent_trainer_Rating(true)

            })
            .catch(function (error) {
                //console.log(error);
            });
    };

    const Delete_Rating = (ID) => {
      
        GetApi(
            `/api/Admin/Delete_Rating_Trainer/${ID}/${Admin_Info.admin_Id}`,
            Admin_Info.jwT_Token_Admin
        ).then(() => {
            alert("تم الحدف");
        });
    };

    const handleClose_DialogContent_trainer_Active = () => {
        setTrainer_Rating_data([])
        setLoading_state_iocn(false)
        setOpen_DialogContent_trainer_Rating(false)
        props.handleClose_DialogContent_trainer_Active()
    };

    if (loading_state_iocn) {
        return (
            <Dialog
                fullWidth={"sm"}
                maxWidth={"sm"}
                open
                onClose={handleClose_DialogContent_trainer_Active}
                aria-labelledby="max-width-dialog-title"
            >
                <CircularProgress />
            </Dialog>

        )

    } else {
        return (
            <Dialog
                fullWidth={"sm"}
                maxWidth={"sm"}
                open={open_DialogContent_trainer_Rating}
                onClose={handleClose_DialogContent_trainer_Active}
                aria-labelledby="max-width-dialog-title"
            >
                <DialogContent>
                    <div>
                        <List>
                            {trainer_Rating_data.length === 0 ? (
                                <label>لايوجد تعليق</label>
                            ) : (
                                trainer_Rating_data.map((Rating) => {
                                    return (
                                        <div>
                                            <div className="w3-cell-row">
                                                <div className="w3-cell w3-container">
                                                    <br></br>

                                                    <span className="span12px">
                                                        {" "}
                                                        {Rating.userName}
                                                    </span>
                                                    <p
                                                        className={
                                                            classes.p_followUp_Schedule_Description
                                                        }
                                                    >
                                                        {" "}
                                                        {Rating.rating_Trainer_Comment}{" "}
                                                    </p>
                                                    <br></br>
                                                    <Grid
                                                        justify="center"
                                                        alignItems="center"
                                                        container
                                                        spacing={8}
                                                    >
                                                        <Grid item xs>
                                                            <button
                                                                size="small"
                                                                variant="contained"
                                                                style={{ backgroundColor: "red" }}
                                                                className={classes.ButtonSubscription}
                                                                onClick={() => {
                                                                    if (
                                                                        window.confirm(
                                                                            "هل متاكد انك تبغى تحدف  ؟؟"
                                                                        )
                                                                    )
                                                                        Delete_Rating(
                                                                            Rating.rating_Trainer_Id
                                                                        );
                                                                }}
                                                            >
                                                                حذف
                                                            </button>
                                                        </Grid>
                                                    </Grid>

                                                </div>
                                            </div>
                                            <hr></hr>
                                        </div>
                                    );
                                })
                            )}
                        </List>
                    </div>
                </DialogContent>
            </Dialog>

        );

    }


}

TrainerRating.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TrainerRating);
